// Custom js (28/6/2023)
$(".productView .reviewApp, .productView .meta_data").wrapAll(
  '<div class="custom_slodout_review" />'
);
$(document).ready(function () {
  if ($(window).width() < 514) {
    $(".custom_accordian .popup-mobile").removeClass();
  }

  // review section

  var svgCode =
    '<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 -6.5 36 36"><path fill="#000" fill-rule="nonzero" d="M10.892.29.35 10.742l-.059.054a.984.984 0 0 0-.291.642v.124c.014.234.11.463.291.642l.052.044L10.892 22.71c.39.387 1.023.387 1.413 0a.985.985 0 0 0 0-1.402l-9.008-8.934h31.704c.552 0 .999-.443.999-.99a.995.995 0 0 0-1-.992H3.533l8.773-8.7a.985.985 0 0 0 0-1.402 1.005 1.005 0 0 0-1.413 0ZM.885 11.383l10.714 10.626L.998 11.5v-.004l.059-.053.06-.06H.885Z"/></svg>';
  var arrowAdd = setInterval(function () {
    if (
      $(".template-index .testi_section.wc_testimonial_section .slick-arrow")
        .length != 0
    ) {
      // console.log("length GET 0000");
      $(
        ".template-index .testi_section.wc_testimonial_section .slick-arrow"
      ).html(svgCode);
      clearInterval(arrowAdd);
    } else {
      // console.log("length not get 1111");
    }
  }, 500);

  setTimeout(function () {
    clearInterval(arrowAdd);
  }, 10000);

  // wishlist

  $(document).on("click", " [data-wishlist]", function () {
    setTimeout(function () {
      wishlistCounter();
    }, 100);
  });

  function wishlistCounter() {
    let wishlistItem = JSON.parse(localStorage.getItem("wishlistItem"));
    $(".wishlist_counter").text(wishlistItem?.length);
  }
  wishlistCounter();

  //Indigrident Section Slider
  var itemcount = $(".indigridents_section .indigridents_List .item").length;
  // console.log(itemcount);
  if (itemcount >= 5) {
    $(".indigridents_section .indigridents_List").slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
          },
        },
      ],
    });
  }

  // Product page custom accordian section
  // console.log("hyyyyyyyy")

  $(document).ready(function () {
    // Find all .Collapsible sections
    $(".Collapsible").each(function () {
      // Check if the <p> tag inside this section is empty
      if ($(this).find(".Collapsible__Content p").html().trim() === "") {
        // console.log("Empty p tag found, removing section");
        // Remove the entire section
        $(this).remove();
      }
    });
  });

  $(".ProductMeta__Description .Product_Data_Tabs .Collapsible__Button").click(
    function () {
      // console.log("Click tab");
      let prent = $(this).closest(".Collapsible");
      prent
        .siblings(".Collapsible")
        .removeClass("open")
        .find(".Collapsible__Content")
        .slideUp();
      if (prent.hasClass("open")) {
        prent.removeClass("open").find(".Collapsible__Content").slideUp();
      } else {
        prent.addClass("open").find(".Collapsible__Content").slideDown();
      }
    }
  );

  function productCustomAccordion(data, accordionData) {
    dataHtml = $(data).html();
    // console.log("dataHtml========",dataHtml)
    $(dataHtml).length != 0
      ? $(dataHtml).appendTo($(accordionData).find(".Collapsible__Content"))
      : $(accordionData).remove();
    $(data).remove();
  }

  // Description JS
  const productDescription = $(".ProductMeta__Description .productDescription");
  const description_accordion = $(
    ".ProductMeta__Description .description_accordion"
  );
  // console.log("productDescription=========", productDescription);
  productCustomAccordion(productDescription, description_accordion);

  // Benefits JS
  const productBenefits = $(".ProductMeta__Description .productwhyitisunique");
  const Why_is_it_unique_accordion = $(
    ".ProductMeta__Description .Why_is_it_unique_accordion"
  );
  productCustomAccordion(productBenefits, Why_is_it_unique_accordion);

  // Usage JS
  const productUsage = $(".ProductMeta__Description .productUsage");
  const usage_accordion = $(".ProductMeta__Description .usage_accordion");
  productCustomAccordion(productUsage, usage_accordion);

  // What's in this combo JS
  const whatsisinthiscombo = $(".ProductMeta__Description .whatsisinthiscombo");
  const whatsisinthiscombo_accordion = $(
    ".ProductMeta__Description .whats_is_in_this_combo"
  );
  productCustomAccordion(whatsisinthiscombo, whatsisinthiscombo_accordion);

  // Ingredients JS
  const productIngredients = $(".ProductMeta__Description .productIngredients");
  const ingredients_accordion = $(
    ".ProductMeta__Description .ingredients_accordion"
  );
  productCustomAccordion(productIngredients, ingredients_accordion);
  $(
    ".template-product .ProductMeta__Description .highlighted_section"
  ).insertAfter(
    ".template-product .ProductMeta__Description .Product_Data_Tabs"
  );
});
